/* ============
 * subscriber Transformer
 * ============
 */

import Transformer from './transformer';

export default class SubscriberTransformer extends Transformer {

  static fetch(subscriber) {
    return {
      id: subscriber.id,
      hash_code: subscriber.hash_code,
      contact_id: subscriber.contact_id,
      name: subscriber.name,
      email: subscriber.email,
      subscribe: subscriber.subscribe,
      created_at: subscriber.created_at,
    };
  }

  static send(subscriber) {
    return {
      contact_ids: subscriber.contact_ids,
    };
  }
}



// WEBPACK FOOTER //
// ./src/app/transformers/subscriber.js